import { isArray, isBlob, isMap, isNone, isNumber, isObject, isSet, isString, isSymbol } from './defineType';

/**
 * 是否为数字
 * @param value 需要校验的值
 * @param options 可选参数
 * @returns boolean
 */
export const validateNumber = (value, options) => {
  var _options$precision;
  let str = '';
  if (isNumber(value)) {
    str = value.toString();
  }
  if (isString(value)) {
    str = value;
  }
  if (str === '') {
    return false;
  }
  const negative = options !== null && options !== void 0 && options.negative ? '-?' : '';
  const precision = (options === null || options === void 0 ? void 0 : options.precision) === 0 ? '' : ".?[0-9]{0,".concat((_options$precision = options === null || options === void 0 ? void 0 : options.precision) !== null && _options$precision !== void 0 ? _options$precision : 99, "}");
  const reg = new RegExp("^".concat(negative, "[0-9]+").concat(precision, "$"));
  return reg.test(str);
};

/**
 * 是否为空（空字符串，空对象，空数组，空Map，空Set，空Blob，空Symbol，NaN，null，undefined）
 * @param value 需要校验的值
 * @returns boolan
 */
export const validateEmpty = value => {
  if (isNone(value)) {
    return true;
  }
  if (isObject(value)) {
    for (let _ in value) {
      return false;
    }
    return true;
  }
  if (isArray(value)) {
    return value.length === 0;
  }
  if (isMap(value) || isSet(value) || isBlob(value)) {
    return value.size === 0;
  }
  if (isSymbol(value)) {
    return isNone(value.description);
  }
  return false;
};